import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

//  Get All
export const GetAllWalletHistory = createAsyncThunk(
  "masters/wallet/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.history}?name=${filter?.name || ""}&wallet_type_id=${filter?.type || ""}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllFundRequest = createAsyncThunk(
  "masters/wallet/get-all-fund",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.FundReq}?name=${filter?.name || ""}&status=${filter?.status || ""}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllWithdrawHistory = createAsyncThunk(
  "masters/wallet/get-all-waithdraw",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.WithdrawReq}?name=${filter?.name || ""}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate}&status=${filter.status || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Get Single
export const GetSingle = createAsyncThunk(
  "masters/wallet/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Wallet}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Create (Add)
export const Create = createAsyncThunk(
  "masters/wallet/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Wallet, data);

      return res; // The new country object
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//  WithdrawStatusChange
export const WithdrawStatusChange = createAsyncThunk(
  "masters/wallet/WithdrawstatusChange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Wallet.WithdrawReq}/${id}`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const DepositeStatusChange = createAsyncThunk(
  "masters/wallet/DepositeStatusChange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Wallet.FundReq}/${id}`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//  Delete
export const Delete = createAsyncThunk(
  "masters/wallet/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Masters.Wallet}/${id}`);
      return id; // Return the id of the deleted country
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Status
export const StatusWithdrawStatusChange = createAsyncThunk(
  "masters/wallet/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Wallet}/${id}`);
      console.log(res, "StatusWithdrawStatusChange");

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllCryptoFundRequest = createAsyncThunk(
  "masters/wallet/get-all-crypto-fund",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.CryptoFundReq}?name=${filter?.name || ""}&status=${filter?.status || ""}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const CryptoDepositeStatusChange = createAsyncThunk(
  "masters/wallet/CryptoDepositeStatusChange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Wallet.CryptoFundReq}/${id}`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const Slice = createSlice({
  name: "wallet",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, WithdrawStatusChange, Delete
      .addCase(GetAllWalletHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWalletHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllWalletHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllFundRequest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllFundRequest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllFundRequest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllWithdrawHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWithdrawHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllWithdrawHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(WithdrawStatusChange.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(WithdrawStatusChange.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (wallet) => wallet.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(WithdrawStatusChange.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (wallet) => wallet.id !== action.payload.id,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusWithdrawStatusChange.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusWithdrawStatusChange.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (wallet) => wallet.id !== action.payload.id,
        ); // Remove the country with the deleted id
      })
      .addCase(StatusWithdrawStatusChange.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllCryptoFundRequest.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCryptoFundRequest.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCryptoFundRequest.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
